export const OPEN_CLOSE_ANIMATION_DURATION = 300;

export default { OPEN_CLOSE_ANIMATION_DURATION };
